import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  InputField, ErrorMessage, TooltipWidget,
} from 'anf-core-react';

export default function CVVField({
  cvv,
  cardBrand,
  label,
  errorMessage,
  index,
  onChange,
  hasValidationError,
  tooltipMessage,
  tooltipImage,
}) {
  const [maxLength, setMaxLength] = useState(3);
  const [isInvalid, setIsInvalid] = useState(false);
  const [isToolTipOpen, setIsToolTipOpen] = useState(false);

  useEffect(() => {
    setIsInvalid(!!hasValidationError);
  }, [hasValidationError]);

  useEffect(() => {
    // Check for amex card brand (code '003' or 'amex')
    if (cardBrand && (String(cardBrand).match(/(amex)|(003)/))) {
      setMaxLength(4);
    } else {
      setMaxLength(3);
    }
  }, [cardBrand]);

  const handleChange = (event) => {
    let input = event.target.value.replace(/\D/g, ''); // Remove non-digits

    // Enforce max length based on card type (3 for most, 4 for Amex)
    if (input.length > maxLength) {
      input = input.substring(0, maxLength);
    }

    onChange(input);
  };

  const validateChange = (event) => {
    const input = event.target.value;
    setIsInvalid(!(input.length === maxLength));
  };

  const tooltipId = `cvv-tooltip-${index}`;

  return (
    <div className="cvv-field">
      <InputField
        label={label}
        name={`creditCard[${index}].cvv`}
        id={`cvv-field-${index}`}
        value={cvv}
        onChange={handleChange}
        onBlur={validateChange}
        type="tel"
        maxLength={maxLength}
        isInvalid={isInvalid}
        autoComplete="cc-csc"
        inputProps={{
          'data-validationrule': 'cvv',
          'data-testid': `cvv-field-${index}`,
        }}
      >
        <TooltipWidget
          buttonLabelText="Security Code Help"
          contentID={tooltipId}
          position="bottom-left"
          isOpen={isToolTipOpen}
          onFocus={() => setIsToolTipOpen(true)}
          onBlur={() => setIsToolTipOpen(false)}
          onClick={() => setIsToolTipOpen(!isToolTipOpen)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setIsToolTipOpen(!isToolTipOpen);
            }
          }}
          onKeyUp={() => {}}
        >
          <div>
            {tooltipImage && (
              <img
                src={tooltipImage}
                alt={tooltipMessage}
                style={{ maxWidth: '200px', height: 'auto' }}
              />
            )}
          </div>
        </TooltipWidget>

        {errorMessage && (
          <ErrorMessage id="cvv-error-message">
            {errorMessage}
          </ErrorMessage>
        )}
      </InputField>
    </div>
  );
}

CVVField.propTypes = {
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  cvv: PropTypes.string,
  index: PropTypes.number,
  cardBrand: PropTypes.string,
  onChange: PropTypes.func,
  hasValidationError: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  tooltipImage: PropTypes.string,
};

CVVField.defaultProps = {
  label: '',
  errorMessage: '',
  cvv: '',
  index: 0,
  cardBrand: '',
  onChange: () => {},
  hasValidationError: false,
  tooltipMessage: '',
  tooltipImage: '',
};
